<ng-container *transloco="let t; prefix: 'shared.languageSwitcher'">
  <mat-form-field class="language-switcher" subscriptSizing="dynamic">
    <mat-label>{{ t('label') }}</mat-label>
    <mat-select
      [value]="language()"
      (selectionChange)="onSelectionChange($event)"
    >
      @for (lang of languages; track lang) {
        <!-- Each option names its language in that language (English /
             Español), so the lang attribute lets screen readers pronounce it. -->
        <mat-option [value]="lang" [attr.lang]="lang">
          {{ t('options.' + lang) }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-container>
